__turbopack_context__.v({
  "_cable": "BenefitsSection-module-scss-module__n251EG___cable",
  "_finance": "BenefitsSection-module-scss-module__n251EG___finance",
  "_tradeIn": "BenefitsSection-module-scss-module__n251EG___tradeIn",
  "_warranty": "BenefitsSection-module-scss-module__n251EG___warranty",
  "card": "BenefitsSection-module-scss-module__n251EG__card",
  "cardContent": "BenefitsSection-module-scss-module__n251EG__cardContent",
  "cards": "BenefitsSection-module-scss-module__n251EG__cards",
  "root": "BenefitsSection-module-scss-module__n251EG__root",
  "title": "BenefitsSection-module-scss-module__n251EG__title",
  "tooltip": "BenefitsSection-module-scss-module__n251EG__tooltip",
  "tooltipButton": "BenefitsSection-module-scss-module__n251EG__tooltipButton",
});
